var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vd-wrapper",style:({'background-color':_vm.backgroundColor })},[_c('div',{ref:"vd",staticClass:"vd"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// F:/projects/nest/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc519c84","hasScoped":true,"buble":{"transforms":{}}}!F:/projects/nest/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/index.vue
// module id = 9
// module chunks = 0